/*
 * Product reviews + the new seller widget on the LEGACY product templates (snippets/rv-reviews.liquid).
 * Same data and the same two drawers (mpd-reviews-sidebar, mpd-seller-sidebar) as the new mobile PDP,
 * whose logic this mirrors — assets/product-page-mobile-pdp.js is not loaded on these templates.
 *
 *  - Rating row -> reviews drawer: the product's own cards in the page's language — strictly for Arabic; for
 *    another language (HK zh-TW, MY ms, TH th: translated borrowed cards) English when it has none yet.
 *  - Words: window.rvI18n (snippets/rv-reviews-i18n.liquid, from locales/*.json → rv_reviews).
 *  - Seller line: whenever the legacy variant script draws "Authenticated & sold by …" into
 *    .supplierDiv, it is redrawn from the variant's seller_ref (name, ★ score) and opens the new
 *    seller drawer, for every variant with a seller_ref — also where the legacy script draws none
 *    (ZA's legacy script skips the seller widget; new sellers have no legacy record). Variants
 *    without a seller_ref keep the legacy line.
 */
(function () {
  'use strict';
  if (window.__rvReviews) return;          // the snippet can render twice (mobile + desktop meta)
  window.__rvReviews = true;

  var pageLang = document.documentElement.lang || 'en';
  var isAr = pageLang.indexOf('ar') === 0;
  var lang = isAr ? 'ar' : pageLang;
  // The page's words (read when used: the drawers' snippet may come after this script), English as the fallback.
  function w(k, en) { var o = window.rvI18n || {}; return o[k] || en; }
  function fill(s, k, v) { return String(s).replace('{' + k + '}', v); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJson(id) { var el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  // DD/MM/YY — the same review-date format as the new PDP.
  function ddmmyy(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    if (m) return m[3] + '/' + m[2] + '/' + m[1].slice(-2);
    var d = new Date(iso); if (isNaN(d)) return '';
    return String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getFullYear()).slice(-2);
  }
  function reviewDate(iso, prefix) { var s = ddmmyy(iso); return s ? (prefix || 'Reviewed on ') + s : ''; }
  // The page's language: the Arabic page never shows an English review; a Chinese, Malay or Thai page shows English
  // where a list has no card in its language yet (a translation not made yet).
  function forPage(list) {
    list = list || [];
    var l = lang;
    if (l !== 'ar' && l !== 'en' && !list.some(function (r) { return r.lang === l; })) l = 'en';
    return list.filter(function (r) { return (r.lang || 'en') === l; }).slice(0, 25);
  }
  function repeats(title, text) {
    var n = function (x) { return String(x || '').toLowerCase().replace(/[\s.!?؟…,،'"“”]+/g, ' ').trim(); };
    return !!title && n(title.replace(/…$/, '')) === n(text);
  }
  function cardLine(r) {
    var p = isAr && r.product_ar || r.product, v = isAr && r.variation_ar || r.variation;
    return [p].concat(String(v || '').split(' / ')).map(function (x) { return String(x || '').trim(); }).filter(Boolean).join(' · ');
  }
  var _sid = 0;
  // Trustpilot-style square stars, always five, the last filled to the fraction (twin of the new PDP's).
  function stars(rating, size) {
    var green = '#00B67A', gray = '#DCDCE6', path = 'M10 1.5L12.1 7.2 18.1 7.4 13.3 11.1 15 16.9 10 13.5 5 16.9 6.7 11.1 1.9 7.4 7.9 7.2Z';
    var rx = Math.max(1, Math.round(size * 0.1)), html = '';
    for (var i = 1; i <= 5; i++) {
      var frac = rating - Math.floor(rating);
      var full = i <= Math.floor(rating) || (frac >= 0.8 && i === Math.ceil(rating));
      var part = !full && i === Math.ceil(rating) && frac > 0;
      var defs = '', fill = gray;
      if (full) fill = green;
      else if (part) {
        var gid = 'rv-g-' + (++_sid), pct = Math.round(frac * 100);
        defs = '<defs><linearGradient id="' + gid + '" x1="' + (isAr ? '100%' : '0%') + '" y1="0%" x2="' + (isAr ? '0%' : '100%') + '" y2="0%"><stop offset="' + pct + '%" stop-color="' + green + '"/><stop offset="' + pct + '%" stop-color="' + gray + '"/></linearGradient></defs>';
        fill = 'url(#' + gid + ')';
      }
      html += '<li style="list-style:none;display:flex;flex-shrink:0"><svg width="' + size + '" height="' + size + '" viewBox="0 0 20 20">' + defs +
        '<rect width="20" height="20" rx="' + rx + '" style="fill:' + fill + '!important;stroke:none!important"/><path d="' + path + '" style="fill:#fff!important;stroke:none!important"/></svg></li>';
    }
    return html;
  }
  function openBody(cls) { document.body.classList.add(cls); document.body.style.overflow = 'hidden'; }
  function closeBody(cls) { document.body.classList.remove(cls); document.body.style.overflow = ''; }

  // The drawers render inside the product's meta block, whose ancestors form a stacking context
  // below the sticky add-to-cart bar (z-index 666 beat the drawers' 999999). Lift them to <body>.
  function lift() {
    document.querySelectorAll('.mpd-reviews-sidebar, .mpd-seller-sidebar').forEach(function (el) {
      if (el.parentElement !== document.body) document.body.appendChild(el);
    });
  }
  // Close on X / outside click / Escape. Bound DIRECTLY: the legacy theme defines its own global
  // closeSupplierDrawer() (it closes the OLD seller drawer), so the drawers' onclick="closeSupplierDrawer()"
  // never reached ours and the new seller drawer stayed open.
  function bindClose() {
    [['.mpd-seller-sidebar', '.mpds-close, .mpds-overlay', 'mpd-seller-sidebar-show'],
     ['.mpd-reviews-sidebar', '.mpdr-close, .mpdr-overlay', 'mpd-reviews-sidebar-show']].forEach(function (d) {
      var root = document.querySelector(d[0]);
      if (!root || root.__rvClose) return;
      root.__rvClose = true;
      root.querySelectorAll(d[1]).forEach(function (el) {
        el.addEventListener('click', function () { closeBody(d[2]); });
      });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeBody('mpd-seller-sidebar-show'); closeBody('mpd-reviews-sidebar-show');
  });
  function ready() { lift(); bindClose(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();

  // ── Reviews drawer ────────────────────────────────────────────────────
  var product = readJson('rv-product-reviews-data');
  var prevCloseReviews = window.closeReviewsDrawer;
  window.closeReviewsDrawer = function () { closeBody('mpd-reviews-sidebar-show'); if (typeof prevCloseReviews === 'function') prevCloseReviews.apply(this, arguments); };
  var rendered = false;
  window.rvOpenReviews = function () {
    var sidebar = document.querySelector('.mpd-reviews-sidebar');
    if (!sidebar || !product) return;
    openBody('mpd-reviews-sidebar-show');
    if (rendered) return;
    rendered = true;
    var i18n = window.mpdReviewsI18n || {};
    var listEl = sidebar.querySelector('#mpdr-list'), stateEl = sidebar.querySelector('#mpdr-state');
    var list = forPage(product.reviews);
    if (stateEl) {
      // A rated product with nothing written in this language says so ("No reviews yet" would
      // contradict the count above it).
      stateEl.textContent = list.length ? '' : ((product.reviews || []).length ? (i18n.emptyLang || i18n.empty || '') : (i18n.empty || 'No reviews yet.'));
      stateEl.style.display = list.length ? 'none' : '';
    }
    if (!listEl) return;
    listEl.innerHTML = list.map(function (r) {
      var desc = r.text && !repeats(r.title, r.text) ? esc(r.text) : '';
      var line = cardLine(r);
      return '<div class="mpdr-review-card">' +
        '<div class="mpdr-verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke-width="1.8"/><path d="M8.5 12l2.4 2.4 4.6-4.8" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(i18n.verified || 'Verified Purchase') + '</div>' +
        '<div class="mpdr-rh"><span class="mpdr-reviewer-name">' + esc(r.name) + '</span><ul class="mpdr-review-stars">' + stars(parseFloat(r.score) || 0, 14) + '</ul></div>' +
        '<div class="mpdr-review-date">' + reviewDate(r.date, i18n.reviewedOn) + '</div>' +
        (r.title ? '<div class="mpdr-review-title">' + esc(r.title) + '</div>' : '') +
        (desc ? '<p class="mpdr-review-text">' + desc + '</p>' : '') +
        (line ? '<div class="mpdr-review-prod">' + esc(line) + '</div>' : '') +
        '</div>';
    }).join('');
  };

  // ── Seller widget ─────────────────────────────────────────────────────
  var sellers = readJson('rv-sellers-data');
  if (!sellers || !sellers.byVariant) return;
  var prevCloseSeller = window.closeSupplierDrawer;
  window.closeSupplierDrawer = function () { closeBody('mpd-seller-sidebar-show'); if (typeof prevCloseSeller === 'function') prevCloseSeller.apply(this, arguments); };

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var v = input && input.value;
    if (!v || !sellers.byVariant[String(v)]) {
      var q = new URLSearchParams(location.search).get('variant');
      if (q) v = q;
    }
    return v ? String(v) : null;
  }
  function sellerFor(vid) { var uid = vid && sellers.byVariant[vid]; return uid ? sellers.sellers[uid] : null; }
  function setText(sel, v) { var el = document.querySelector(sel); if (el) el.textContent = v == null ? '' : v; }

  var shown = null, swiper = null;
  function fillDrawer(s) {
    var root = document.querySelector('.mpd-seller-sidebar');
    if (root) root.classList.add('mpds--v2');   // badge values carry their own words ("761+ Sales"): hide the old labels, as the new PDP does
    var score = parseFloat(s.score) || 0;
    setText('.mpds-name', s.name);
    var st = document.querySelector('.mpds-stars'); if (st) st.innerHTML = stars(score, 20);
    setText('.mpds-score', score.toFixed(1));
    var rc = parseInt(s.review_count, 10) || 0;   // the real count: hidden under 25, "N+" from 25, "1,000+" at most
    setText('.mpds-review-count', rc >= 25 ? '(' + fill(w('reviewsCount', '{n}+ reviews'), 'n', rc >= 1000 ? '1,000' : rc.toLocaleString('en')) + ')' : '');
    var top = document.querySelector('.mpds-topseller'); if (top) top.style.display = s.top_seller === true ? '' : 'none';
    var sales = parseInt(s.sales, 10) || 0;
    setText('.mpds-sales', sales ? fill(w('salesCount', '{n}+ Sales'), 'n', sales.toLocaleString('en')) : '–');
    if (s.ships_in) {
      var days = String(s.ships_in).replace(/\s*days?\s*$/i, '').replace('-', '–');
      setText('.mpds-ships-val', fill(w('shipsIn', 'Typically ships in {days} days'), 'days', days));
    }
    var reviews = forPage(s.reviews), wrap = document.querySelector('.mpds-swiper .swiper-wrapper');
    var verified = esc(w('verified', 'Verified Purchase')), on = w('reviewedOn', 'Reviewed on ');
    if (wrap) wrap.innerHTML = reviews.map(function (r) {
      return '<div class="swiper-slide mpds-review-card">' +
        '<div class="mpds-verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="fill:none!important;width:14px!important;height:14px!important;"><circle cx="12" cy="12" r="9" stroke="#0E7C5E" stroke-width="1.8" style="stroke:#0E7C5E!important"/><path d="M8.5 12l2.4 2.4 4.6-4.8" stroke="#0E7C5E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="stroke:#0E7C5E!important;fill:none!important"/></svg>' + verified + '</div>' +
        '<div class="mpds-rh"><span class="mpds-reviewer-name">' + esc(r.name) + '</span><ul class="mpds-review-stars">' + stars(parseFloat(r.score) || 0, 14) + '</ul></div>' +
        '<div class="mpds-review-date">' + reviewDate(r.date, on) + '</div>' +
        (r.title ? '<h4 class="mpds-review-title">' + esc(r.title) + '</h4>' : '') +
        (repeats(r.title, r.text) ? '' : '<p class="mpds-review-text">' + esc(r.text) + '</p>') +
        '<div class="mpds-review-prod">' + esc(cardLine(r)) + '</div></div>';
    }).join('');
    var sect = document.querySelector('.mpds-reviews-sect'); if (sect) sect.style.display = reviews.length ? '' : 'none';
    var nav = document.querySelector('.mpds-swiper-nav'); if (nav) nav.style.display = reviews.length > 1 ? '' : 'none';
    if (swiper) { swiper.update(); swiper.slideTo(0, 0); }
  }
  window.rvOpenSeller = function () {
    var s = sellerFor(currentVariantId()) || shown;
    if (!s) return;
    fillDrawer(s);
    openBody('mpd-seller-sidebar-show');
    // A theme whose seller drawer scrolls the cards natively (ZA: CSS scroll-snap, no Swiper) must not get
    // a Swiper on top of it — the two fight over the same track.
    var track = document.querySelector('.mpds-swiper .swiper-wrapper');
    var native = track && /auto|scroll/.test(getComputedStyle(track).overflowX);
    if (!swiper && !native && window.Swiper && document.querySelector('.mpds-swiper')) {
      swiper = new window.Swiper('.mpds-swiper', {
        slidesPerView: 1.15, spaceBetween: 12, grabCursor: true,
        scrollbar: { el: '.mpds-swiper-nav .swiper-scrollbar', draggable: true },
        navigation: { prevEl: '.mpds-swiper-prev', nextEl: '.mpds-swiper-next' },
        mousewheel: { forceToAxis: true, releaseOnEdges: true }
      });
    }
  };

  // Redraw the legacy line (same classes, so the legacy styling holds) from seller_ref. Our markup
  // carries a hidden data-rv-mark: MutationObserver callbacks run AFTER the write, so a flag can't
  // tell our own redraw from the legacy script's — the mark can.
  function apply() {
    var vid = currentVariantId(), s = sellerFor(vid);
    if (!s) return;
    var score = parseFloat(s.score) || 0, half = Math.round(score * 2) / 2;
    var label = esc(w('soldBy', 'Authenticated & sold by'));
    var html = '<div class="seller-info"><span>' + label + ' </span></div>' +
      '<div class="seller-rating-stars"><a href="#" class="seller-name" onclick="window.rvOpenSeller();return false;">' + esc(s.name) + '</a>' +
      '<ul class="rating sp_ratings" data-rating="' + half + '"><li class="rating__item"></li><li class="rating__item"></li><li class="rating__item"></li><li class="rating__item"></li><li class="rating__item"></li></ul>' +
      '<span class="rating-value">' + score.toFixed(1) + '/5</span></div>' +
      '<span data-rv-mark="' + esc(vid) + '" hidden></span>';
    document.querySelectorAll('.supplierDiv').forEach(function (el) {
      var mark = el.querySelector('[data-rv-mark]');
      if (mark && mark.getAttribute('data-rv-mark') === vid) return;   // already ours, this variant
      el.innerHTML = html;
    });
    shown = s;
  }
  var pending = null;
  function later() { clearTimeout(pending); pending = setTimeout(apply, 60); }
  function start() {
    document.querySelectorAll('.supplierDiv').forEach(function (el) {
      new MutationObserver(function () { if (!el.querySelector('[data-rv-mark]')) later(); }).observe(el, { childList: true });
    });
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], .productView-options, .halo-productOptions, [data-product-variant]')) later(); }, true);
    later();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
